<template>
    <modal v-model="showModal">
        <template #title>{{ meetingTitle }}</template>
        <p>{{ trans('apps.team_meetings.recurring_text_1') }}</p>
        <p>{{ trans('apps.team_meetings.recurring_text_2') }}</p>

        <new-recurring-action-choices
            v-if="meeting"
            v-model="applyRecurringActionTo"
            :type="type"
        />

        <template #footer>
            <ep-button
                :variant="type === 'delete' ? 'danger' : 'primary'"
                :loading="loading"
                :disabled="loading"
                @click="update"
            >
                {{ type === 'delete' ? trans('global.delete') : trans('global.update') }}
            </ep-button>
        </template>
    </modal>
</template>

<script>
import Modal from '@/system/components/global/Modal';
import NewRecurringActionChoices from '@/system/components/apps/NewRecurringActionChoices';
import { moveTeamMeetingRequest } from 'Components/apps/team_meetings/TeamMeetingsService';

export default {
    components: {
        NewRecurringActionChoices,
        Modal
    },

    data() {
        return {
            showModal: false,
            meeting: null,
            applyRecurringActionTo: 'this',
            type: 'delete',
            loading: false,
            undoFunction: null
        };
    },

    computed: {
        meetingTitle() {
            if (this.type === 'delete') {
                return this.trans('apps.team_meetings.delete' )
            } else if (this.type === 'move') {
                return this.trans('apps.team_meetings.move' )
            } else {
                return this.trans('apps.team_meetings.update' )
            }
        },
    },

    watch: {
        showModal(val) {
            if (!val) {
                this.handleMoveClose();
            }
        },
    },

    mounted() {
        this.showMeetingRecurringModalEventHandler();
        this.recurringTeamMeetingAdjustedEventListener();
    },

    methods: {
        showMeetingRecurringModalEventHandler() {
            this.$event_bus.$on('showMeetingRecurringModal', (meeting, type, undoFunction = null) => {
                this.reset();
                this.meeting = meeting;
                this.type = type;
                this.showModal = true;
                this.undoFunction = undoFunction;
            });
        },

        update() {
            if (this.type === 'delete') {
                this.triggerRecurringDelete();
                return;
            }

            if (this.type === 'move') {
                this.triggerRecurringMove();
                return;
            }

            this.triggerRecurringUpdate();
        },

        triggerRecurringDelete() {
            this.$event_bus.$emit('deleteRecurringTeamMeetings', this.applyRecurringActionTo);
        },

        triggerRecurringUpdate() {
            this.$event_bus.$emit('updateRecurringTeamMeetings', this.applyRecurringActionTo);
        },

        async triggerRecurringMove() {
            await moveTeamMeetingRequest(this.meeting, this.undoFunction, this.applyRecurringActionTo);
            this.$event_bus.$emit('recurringTeamMeetingAdjusted');
        },

        recurringTeamMeetingAdjustedEventListener() {
            this.$event_bus.$on('recurringTeamMeetingAdjusted', () => {
                // we don't need to revert the action here, because the action has already been applied.
                this.undoFunction = null;
                this.$event_bus.$emit('calendarReload');
                this.showModal = false;
            });
        },

        reset() {
            this.meeting = null;
            this.applyRecurringActionTo = 'this';
            this.loading = false;
            this.undoFunction = null;
        },

        handleMoveClose() {
            if (this.undoFunction) {
                this.undoFunction();
            }
        },
    },
};
</script>
